module.exports = __webpack_public_path__ + "assets/media/image-add.d6179586.svg";